<script setup lang="ts">
interface UnCheckedCircle {
	size?: string;

	class?: string;
}
const props = defineProps<UnCheckedCircle>();
</script>
<template>
	<svg
		:width="size || '20'"
		:height="size || '20'"
		:class="props.class"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10Z"
			fill="white"
		/>
		<path
			d="M0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10Z"
			stroke="#D6D6D6"
		/>
	</svg>
</template>
